module.exports = __webpack_public_path__ + "img/slider-accueil-knett-roulotte.88584310.jpg";